export default (theme) => ({
    containerBotones: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        marginBottom: '30px',
    },

    btnCancelar: {
        marginRight: '8px',
        padding: '10px 55px',
    },

    btnEnviar: {
        marginLeft: '8px',
    },
});
